'use client';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import {
  setGeneralSettings,
  setBusinessSettings,
} from '@/lib/redux/features/settingsSlice';
import { API_GENERAL_SETTINGS, API_BUSINESS_SETTINGS } from '@/constant/apiRout';

export default function SettingsInitializer() {
  const dispatch = useDispatch();

  useEffect(() => {
    const initializeSettings = async () => {
      try {
        const [generalRes, businessRes] = await Promise.all([
          axios.get(`${process.env.NEXT_PUBLIC_BACKEND_URL}${API_GENERAL_SETTINGS}`, {
            params: { tags: ['general-settings'] },
          }),
          axios.get(`${process.env.NEXT_PUBLIC_BACKEND_URL}${API_BUSINESS_SETTINGS}`, {
            params: { tags: ['business-settings'] },
          }),
        ]);

        dispatch(setGeneralSettings(generalRes.data?.data || null));
        dispatch(setBusinessSettings(businessRes.data?.data || null));
      } catch (error) {
        console.error('Failed to initialize settings:', error);
      }
    };

    initializeSettings();
  }, [dispatch]);

  return null;
}
